export default "__VITE_ASSET__C7WXw$ru__"